module.exports = __webpack_public_path__ + "img/poker-s04.26acedd2.svg";